import { render, staticRenderFns } from "./TDS.vue?vue&type=template&id=edcc0ac6"
import script from "./TDS.vue?vue&type=script&lang=js"
export * from "./TDS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports